import styled from 'styled-components'
import Modal, { ModalContentWrapper } from 'components/Modal'

export const DeleteAccountModalContainer = styled(Modal)`
  .Overlay {
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }

  ${ModalContentWrapper} {
    width: fit-content;
  }
`
Modal.defaultProps = {
  dataTestId: 'delete-account-modal-modal',
}
